import React from 'react';
import { CASE_REVIEW_STATUS_ACCEPTED } from './CaseConstants';
import CaseList from './CaseList';
import { APP_TERMS } from '../../app-terms';
const BREAD_CRUMBS = [
  { label: 'Case', to: '/user/case/completed' },
  { label: 'Completed', to: '/user/case/completed' },
];
const CompletedCases = () => {
  return (
    <div>
      <div>
        <CaseList
          title={APP_TERMS.completed_case_list_title}
          caseReviewStatus={CASE_REVIEW_STATUS_ACCEPTED}
          breadCrumbItems={BREAD_CRUMBS}
        />
      </div>
    </div>
  );
};

export default CompletedCases;
